import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IFoodGroup} from '../../models/food-group';

@Component({
  selector: 'app-card-meal-plan',
  templateUrl: './card-meal-plan.component.html',
  styleUrls: ['./card-meal-plan.component.scss']
})
export class CardMealPlanComponent implements OnInit {

  @Input() foodGroup: IFoodGroup;
  @Output() modify: EventEmitter<string> = new EventEmitter();
  @Output() clone: EventEmitter<string> = new EventEmitter();
  @Output() delete: EventEmitter<string> = new EventEmitter();
  // solo de prueba
  tags: any[] = [];
  constructor() { }

  ngOnInit(): void {
    this.initValues();
  }

  initValues(): void {
  }

  /**
   * Emite al componente padre cuando se quiere modificar un platillo.
   */
  onEmitModify(): void {
    this.modify.emit(this.foodGroup._id);
  }

  /**
   * Emite al componente padre cuando se quiere clonar un platillo.
   */
  onEmitClone(): void {
    this.clone.emit(this.foodGroup._id);
  }

  /**
   * Emite al componente padre cuando se quiere eliminar un platillo.
   */
  onEmitDelete(): void {
    this.delete.emit(this.foodGroup._id);
  }
}
